<script setup>
import Card from "~/components/public/Card.vue";
import Heading3 from "~/components/public/Heading3.vue";
import ButtonOutline from "~/components/public/ButtonOutline.vue";
import CalendarIcon from "~/components/public/CalendarIcon.vue";

const publicSiteData = useState('publicSiteData');
const { fullDate } = useDateUtils();
const route = useRoute();

const { data: meetings } = await useAsyncData(
    'featured-meetings',
    async () => {
        if (!publicSiteData.value?.organization_id) {
            if (process.server) {
                return [];
            }
        }

        if (publicSiteData.value?.organization_id) {
            try {
                const response = await publicFetch('/public-sites/featured-meetings');
                return response.data || [];
            } catch (error) {
                return [];
            }
        }
        return [];
    },
    {
        server: true,
        lazy: false,
        watch: [publicSiteData]
    }
);
</script>

<template>
    <div v-if="meetings && meetings.length > 0">
        <Heading3 class="mb-4">Featured meetings</Heading3>
        <div class="grid sm:grid-cols-2 gap-4">
            <Card v-for="meeting in meetings" :key="meeting.id" class="flex flex-col justify-between">
                <div class="flex gap-4">
                    <CalendarIcon :date="meeting.start" size="medium"></CalendarIcon>
                    <div>
                        <div class="font-bold mb-1">
                            <NuxtLink :to="`/${route.params.site_slug}/meetings/${meeting.slug}`">
                                {{ meeting.title }}
                            </NuxtLink>
                        </div>
                        <ClientOnly>
                            <div class="text-gray-700 text-sm font-light">{{ fullDate(meeting.start) }}</div>
                            <template #fallback>
                                <div class="text-gray-700 text-sm font-light">&nbsp;</div>
                            </template>
                        </ClientOnly>
                    </div>
                </div>
                <div class="mt-4">
                    <ButtonOutline :to="`/${route.params.site_slug}/meetings/${meeting.slug}`">View agenda & details</ButtonOutline>
                </div>
            </Card>
        </div>
    </div>
</template>